/* eslint-disable max-classes-per-file */
import { QuestionModel } from 'core/models/elements/questions/question.abstract.model';

/**
 * @class Defines a hotspot question.
 */
export class PdfPageContentModel extends QuestionModel {
  /**
   * @constructor Creates an instance of a hotspot question built from an original data from the API.
   * @param {bo} bo is the basic object come from API.
   */
  constructor(bo) {
    super(bo);
    this.url = bo.url;
    this.pdfPagesSelection = bo.pdf_pages_selection;
    this.minPageNumber = bo.min_page_number;
    this.maxPageNumber = bo.max_page_number;
  }
}
